<template>
  <div class="donut-size" style="font-size:4.4em;" percent="">
    <div class="pie-wrapper">
      <span class="label" style="display:none">
        <span class="num">0</span><span class="smaller">%</span>
      </span>
      <div class="pie">
        <div class="left-side half-circle"></div>
        <div class="right-side half-circle"></div>
      </div>
      <div class="shadow"></div>
    </div>
  </div>
</template>
<style type="text/css" scoped>
.donut-size {
  font-size: 3.9em;
}

.donut-size div, .donut-size div:before, .donut-size div:after {
  box-sizing: border-box;
}

.pie-wrapper {
  position: relative;
  width: 1em;
  height: 1em;
  margin: 0px auto;
}

.pie-wrapper .pie {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  clip: rect(0, 1em, 1em, 0.5em);
}

.pie-wrapper .half-circle {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  border: 0.1em solid #ea695c;
  border-radius: 50%;
  clip: rect(0em, 0.5em, 1em, 0em);
}

.pie-wrapper .right-side {
  transform: rotate(0deg);
}

.pie-wrapper .label {
  position: absolute;
  top: 0.52em;
  right: 0.4em;
  bottom: 0.4em;
  left: 0.4em;
  display: block;
  background: none;
  border-radius: 50%;
  color: #ea695c;
  font-size: 0.25em;
  line-height: 2.6em;
  text-align: center;
  cursor: default;
  z-index: 2;
}

.pie-wrapper .smaller {
  padding-bottom: 20px;
  color: #d0d1d2;
  font-size: .45em;
  vertical-align: super;
}

.pie-wrapper .shadow {
  width: 100%;
  height: 100%;
  border: 0.1em solid #d0d1d2;
  border-radius: 50%;
}

</style>
<script>
import $ from 'jquery'
export default {
  props: {
    percent: Number
  },
  mounted: function () {
    let el = $(this.$el)
    let percent = this.percent
    let donut = true
    percent = Math.round(percent)
    if (percent > 100) {
      percent = 100
    } else if (percent < 0) {
      percent = 0
    }
    var deg = Math.round(360 * (percent / 100))

    if (percent > 50) {
      el.find('.pie').css('clip', 'rect(auto, auto, auto, auto)')
      el.find('.right-side').css('transform', 'rotate(180deg)')
    } else {
      el.find('.pie').css('clip', 'rect(0, 1em, 1em, 0.5em)')
      el.find('.right-side').css('transform', 'rotate(0deg)')
    }
    if (donut) {
      el.find('.right-side').css('border-width', '0.2em')
      el.find('.left-side').css('border-width', '0.2em')
      el.find('.shadow').css('border-width', '0.2em')
    } else {
      el.find('.right-side').css('border-width', '0.5em')
      el.find('.left-side').css('border-width', '0.5em')
      el.find('.shadow').css('border-width', '0.5em')
    }
    el.find('.num').text(percent)
    el.find('.left-side').css('transform', 'rotate(' + deg + 'deg)')
  }
}
</script>
